<template>
    <div class="el-input">
        <input 
            type="text"
            ref="autocomplete"
            class="el-input__inner"
            @keyup="autocompleteTextChanged"
            v-model="formData.location"/>
    </div>
</template>

<script>
    export default {
        props: {
            gmapsObj: { type: Object, required: true },
            map: { type: Object, required: false },
            location: { type: String, required: false },
        },
        data() {
            return {
                formData: {
                    location: this.location,
                    locationName: '',
                    lat: '',
                    lng: '',
                    administrativeAreaLevel1: '',
                    locality: '',
                },
                isState: false,
                errorMessage: null,
                autocomplete: null,
            };
        },
        watch: {
            location(newLocation, oldLocation) {
                this.formData.location = newLocation;
            }
        },
        methods: {
            initAutocomplete() {
                this.autocomplete = new this.gmapsObj.places.Autocomplete(this.$refs.autocomplete, {
                    types: ["(regions)"]
                });

                if (this.map !== null) {
                    this.autocomplete.bindTo('bounds', this.map);
                }

                this.autocomplete.setComponentRestrictions({ country: 'us' });
                this.autocomplete.addListener('place_changed', this.onPlaceChanged);
            },
            autocompleteTextChanged() {
                this.$set(this.formData, 'lat', '');
                this.$set(this.formData, 'lng', '');
                this.$set(this.formData, 'administrativeAreaLevel1', '');
                this.$set(this.formData, 'locality', '');

                this.isState = false;
            },
            onPlaceChanged() {
                this.errorMessage = null;
                const place = this.autocomplete.getPlace();

                if (!place.geometry || typeof place.address_components === 'undefined') {
                    this.errorMessage = 'No such place found.';
                    return;
                }

                this.$set(this.formData, 'location', this.$refs.autocomplete.value);
                this.$set(this.formData, 'locationName', this.$refs.autocomplete.value);
                this.$set(this.formData, 'lat', place.geometry.location.lat());
                this.$set(this.formData, 'lng', place.geometry.location.lng());

                for(let index in place['address_components']) {
                    if (!place['address_components'].hasOwnProperty(index)) continue;
                    place['address_components'][index].types.forEach(type => {
                        switch(type) {
                            case 'locality':
                                this.$set(this.formData, 'locality', place['address_components'][index]['long_name']);
                                break;
                            case 'administrative_area_level_1':
                                this.$set(this.formData, 'administrativeAreaLevel1',
                                    place['address_components'][index]['long_name']);
                                break;
                        }
                    });
                }

                this.isState = this.formData.locality === '';

                this.$emit('updated', this.formData);
            }
        },
        mounted() {
            this.initAutocomplete();
        },
    };
</script>